<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XtyJ2s/media/FC-9781398407466.jpg?1695340671761" alt="This image is the cover for the book Shadow's Revenge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shadow's Revenge
      </h1>
      <p class="bookDescription body article font2">
        <p>In Shadow’s Revenge, Amy finds herself pulled back into the magical world she once knew so well. Years after her first journey through the gate, she is now a grown woman with a child of her own. But when her daughter tells her about a magical gate in their garden, Amy can’t resist the call to adventure once more. As Amy steps back into the world of fairies and enchantment, she reunites with old friends Thorn, Amy, and Brownie. But their mission is urgent: they must stop Shadow, a banished entity who has returned and threatens to take over fairyland. Their task becomes even more perilous when they learn that they must also rescue the daughter of the guardian of the land of the moving rocks. Together, Amy and her companions journey through the land of temptations and face numerous trials and dangers. From the field of illusions to the winter wonderland of Jack Frost, their quest takes them to unexpected places. As the stakes grow higher, Amy must race against time to save her daughter and the other captives before Shadow’s revenge is complete. Will they succeed in their quest, or will Shadow triumph and take over fairyland once and for all? Find out by stepping through the gate - if you dare.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Earle
      </h2>
      
      <p class="authorDescription body article">Julie Earle was born in 1976 and raised in Luton, England. Her father told her fairy stories from his own imagination which captivated her into a fantasy world. As she grew up, she took her imaginative skills to school and got her first story published in the school magazine. After leaving school, Julie worked in a small playgroup filling children’s imagination with all her stories. She loved working with children and went on to receive a diploma in nursery nursing. She now lives in Essex with her husband and five children. Her passion for writing took over and she became a member of a freelance writing group. After having her fourth child, Julie began to create The Magical Gate series; and so it was born.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0178032f